import React from 'react'

import {
  Like,
  Dislike,
  Chat,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, number, oneOf } from 'prop-types'

import { FILTER_TYPES } from '../../constants'
import SidebarButton from './Components/SidebarButton/SidebarButton'

function Posts({
  handleFilterChange,
  commentsCount = 0,
  likeCount = 0,
  dislikeCount = 0,
  filterBy = FILTER_TYPES.COMMENTS,
}) {
  return (
    <div className="review-sidebar__actions" role="tablist" aria-label="Filter reviews">
      <SidebarButton
        icon={Like}
        iconColor="light"
        backgroundColor="green"
        onClick={() => handleFilterChange(FILTER_TYPES.POSITIVE)}
        count={likeCount}
        isActive={filterBy === FILTER_TYPES.POSITIVE}
        ariaLabel={`Filter by likes (${likeCount})`}
        role="tab"
        ariaSelected={filterBy === FILTER_TYPES.POSITIVE}
      />
      <SidebarButton
        icon={Dislike}
        iconColor="light"
        backgroundColor="orange"
        onClick={() => handleFilterChange(FILTER_TYPES.NEGATIVE)}
        count={dislikeCount}
        isActive={filterBy === FILTER_TYPES.NEGATIVE}
        ariaLabel={`Filter by dislikes (${dislikeCount})`}
        role="tab"
        ariaSelected={filterBy === FILTER_TYPES.NEGATIVE}
      />
      <SidebarButton
        icon={Chat}
        iconColor="dark"
        backgroundColor="gray"
        onClick={() => handleFilterChange(FILTER_TYPES.COMMENTS)}
        count={commentsCount}
        isActive={filterBy === FILTER_TYPES.COMMENTS}
        ariaLabel={`Filter by comments (${commentsCount})`}
        role="tab"
        ariaSelected={filterBy === FILTER_TYPES.COMMENTS}
      />
    </div>
  )
}

Posts.propTypes = {
  handleFilterChange: func.isRequired,
  commentsCount: number,
  likeCount: number,
  dislikeCount: number,
  filterBy: oneOf([FILTER_TYPES.POSITIVE, FILTER_TYPES.NEGATIVE, FILTER_TYPES.COMMENTS]),
}

export default Posts
